var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block",class:{
        padded: _vm.padded,
    }},_vm._l((_vm.genres),function(genre,index){return _c('GenreGridTile',{key:'genre-' + genre.id,staticClass:"tile",attrs:{"genre":genre,"index":index,"is-following":_vm.followedGenreIdsSet.has(genre.id),"has-options":_vm.hasOptions},on:{"toggle-follow":_vm.handleToggleFollow}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }